import { useCallback, useState } from "react";
import { buildAllVisibleStatuses } from "../../utils";
import type {
  VisualDiffKind,
  VisualDiffStatus,
} from "../../../utils/computeVisualDiff";
import type { UseVisualDiffFilters } from "./types";

export const useVisualDiffFilters: UseVisualDiffFilters = () => {
  const [activeKind, setActiveKind] = useState<VisualDiffKind>("elements");
  const [visibleStatuses, setVisibleStatuses] = useState(
    buildAllVisibleStatuses,
  );
  const [selectedTypeKey, setSelectedTypeKey] = useState<string | null>(null);

  // Re-picking the active kind would otherwise wipe the type the user is inspecting.
  const selectKind = useCallback(
    (kind: VisualDiffKind) => {
      if (kind === activeKind) return;
      setActiveKind(kind);
      setSelectedTypeKey(null);
    },
    [activeKind],
  );

  const toggleStatus = useCallback((status: VisualDiffStatus) => {
    setVisibleStatuses((previous) => ({
      ...previous,
      [status]: !previous[status],
    }));
  }, []);

  const clearTypeSelection = useCallback(() => {
    setSelectedTypeKey(null);
  }, []);

  return {
    activeKind,
    visibleStatuses,
    selectedTypeKey,
    selectKind,
    toggleStatus,
    selectTypeKey: setSelectedTypeKey,
    clearTypeSelection,
  };
};
